<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Learn about wind damage to buildings
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                General information about wind damage
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background ">
        <v-breadcrumbs divider=">">
          <v-breadcrumbs-item @click="gotoDamage">Damage</v-breadcrumbs-item>
          <v-breadcrumbs-item @click=""> > </v-breadcrumbs-item>
          <v-breadcrumbs-item @click="gotoWind">Wind Damage</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-layout column wrap class="" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">Wind Damage</h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pl-2 pr-2 pt-2">
                The extremely strong winds generated during tropical cyclones
                apply significant pressures on the external surfaces of
                buildings. The wind forces applied to a building can be affected
                by its location:
              </p>

              <ul class="pl-2 pr-2 ">
                <li>
                  Buildings located on a beachfront, or open terrain are exposed
                  to stronger winds and must be designed and built using more
                  robust materials and design criteria than buildings located in
                  built-up areas further inland.
                </li>
                <li>
                  Buildings located on hilltops can experience much higher wind
                  gusts than those on lower-lying flat land. As a general rule,
                  the better the view, the more vulnerable the building is to
                  wind damage and the stronger the building needs to be.
                </li>
              </ul>

              <p class=" pt-2 pl-2 pr-2 ">
                All parts of the building must work together to resist the
                extremely high wind forces generated during tropical cyclones.
                If there is a weakness in the building structure, then wind can
                lift off all of the elements above that weakness.
              </p>
              <p>
                A complex interaction of many factors contribute to the level of
                wind damage to a building including:
              </p>

              <ul>
                <li>
                  the wind speeds at the property
                </li>
                <li>
                  whether the building has been designed to the correct site
                  wind speed
                </li>
                <li>
                  whether appropriate building materials have been selected, and
                </li>
                <li>
                  whether adequate maintenance has been undertaken to keep all
                  elements in good condition.
                </li>
              </ul>

              <p class=" pt-2 pl-2 pr-2 ">
                Roofs, windows, doors and garage doors can often be damaged by
                the wind during tropical cyclones:
              </p>
            </div>
          </v-flex>
          <v-flex style=" width: 100%" class="mb-5">
            <v-carousel style="height: 100%; width: 100%" :cycle="cycle" dark>
              <v-carousel-item
                v-for="(item, i) in windItems"
                :src="item.name"
                :key="i"
              >
                <v-responsive dark>
                  <v-container fill-height>
                    <v-layout align-center>
                      <v-flex aling-start justify-center>
                        <h3 class="display-1 white--text">
                          {{ item.heading }}
                        </h3>
                        <span class="subheading white--text font-weight-bold">{{
                          item.text
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">Wind-borne Debris Damage</h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pl-2 pr-2 pt-2">
                Because tropical cyclones generate very high winds over many
                hours, debris that may have come from damaged buildings, broken
                trees, or objects left lying around is picked up by the wind and
                can cause damage to buildings or ancillary items.
              </p>
              <p>
                Wind-borne debris can include:
              </p>
              <ul>
                <li>
                  Vegetation – branches from trees or shrubs
                </li>
                <li>
                  Loose, lightweight materials such as stored building
                  materials, garden furniture, tools or equipment
                </li>
                <li>
                  Items such as boats, trailers and caravans
                </li>
                <li>
                  Larger unanchored items such as shipping containers
                </li>
                <li>
                  Sheds, gazebos, pergolas and shade sail structures
                </li>
                <li>
                  Detached pieces from buildings that have been damaged. e.g.
                  roof panels.
                </li>
              </ul>

              <p class="pl-2 pr-2 pt-2">
                Some building elements are particularly vulnerable to impact
                from wind-borne debris. They are mainly fragile building
                elements including:
              </p>
              <ul>
                <li>
                  Windows
                </li>
                <li>
                  Doors
                </li>
                <li>
                  Garage doors
                </li>
                <li>
                  Brittle cladding such as asbestos or fibro cement sheets or
                </li>
                <li>
                  Light external elements such as gutters and flashing
                </li>
              </ul>

              <p class="pl-2 pr-2 pt-2">
                Unprotected windows and glass doors can be broken by either wind
                forces or debris. The damage can be difficult to clean up. Glass
                fragments spread throughout a building or grounds can delay the
                return of service of some buildings.
              </p>

              Some building elements may be designed to resist impact from
              wind-borne debris. Windows and doors can be protected by debris
              screens and shutters.
            </div>
          </v-flex>
          <v-flex style=" width: 100%">
            <v-carousel style="height: 100%; width: 100%" :cycle="cycle" dark>
              <v-carousel-item
                v-for="(item, i) in debrisItems"
                :src="item.name"
                :key="i"
              >
                <v-responsive dark>
                  <v-container fill-height>
                    <v-layout align-center>
                      <v-flex aling-start justify-center>
                        <h3 class="display-1 white--text">
                          {{ item.heading }}
                        </h3>
                        <span class="subheading white--text font-weight-bold">{{
                          item.text
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <Footer></Footer>
  </v-content>
</template>

<style>
  .v-breadcrumbs__item{
    color: #1976D2;
    cursor: pointer;
  }
</style>

<script>
import image1 from "../assets/wind-1.jpg";
import image2 from "../assets/1_wind.jpg";
import image3 from "../assets/2_wind.jpg";
import image4 from "../assets/3_wind.jpg";
import image5 from "../assets/4_wind.jpg";
import image6 from "../assets/5_wind.jpg";
import image7 from "../assets/6_wind.jpg";
import image8 from "../assets/7_wind.jpg";
import image9 from "../assets/8_wind.jpg";
import image10 from "../assets/9_wind.jpg";
import image11 from "../assets/10_wind.jpg";
import image12 from "../assets/11_wind.jpg";
import image13 from "../assets/12_wind.jpg";
import image14 from "../assets/11_debris.jpg";
import image15 from "../assets/13_debris.jpg";
import image16 from "../assets/14_debris.jpg";
import image17 from "../assets/16_debris.jpg";
import Footer from "./Footer.vue";
import Navbar from "./Navbar.vue";
import { router } from "../router";

export default {
  name: "Wind",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm",
    cycle: false,
    windItems: [
      {
        name: image1,
        heading: "Roof Loss",
        text: "Total roof loss on an apartment building  "
      },
      {
        name: image2,
        heading: "Roof Loss",
        text: "Damage to roof structure and roof cladding peeled back "
      },
      {
        name: image3,
        heading: "Roof Loss",
        text: "Roof loss on three storey apartments"
      },
      {
        name: image4,
        heading: "Roof Tile Loss",
        text: "Loss of roof tiles"
      },
      {
        name: image5,
        heading: "Flashing Loss",
        text: "Loss of flashings that led to water entering the building "
      },
      {
        name: image6,
        heading: "Flashing Loss",
        text: "Loss of flashings that led to water entering the building "
      },
      {
        name: image7,
        heading: "Flashing Loss",
        text: "Loss of flashings that led to water entering the building "
      },
      {
        name: image8,
        heading: "Damage to Soffits",
        text: "Damage to brittle eaves linings and outdoor ceilings (soffits) "
      },
      {
        name: image9,
        heading: "Window Damage",
        text:
          "Window damage to an apartment building that led to ceiling and roof damage "
      },
      {
        name: image10,
        heading: "Window and Door Damage",
        text: "Damage to windows and doors "
      },
      {
        name: image11,
        heading: "Window and Door Damage",
        text: "Damage to windows and doors "
      },
      {
        name: image12,
        heading: "Garage Doors",
        text: "Damage to garage doors "
      },
      {
        name: image13,
        heading: "Flashing Loss",
        text: "Loss of flashings that led to water entering the building "
      }
    ],
    debrisItems: [
      {
        name: image14,
        heading: "Roof Damage",
        text:
          "Damage to the roof of an apartment building caused by parts of another damaged building "
      },
      {
        name: image15,
        heading: "Window Damage",
        text: "Window broken by debris"
      },
      {
        name: image16,
        heading: "Door Damage",
        text: "Sliding glass door damaged by wind-borne debris"
      },
      {
        name: image17,
        heading: "Roof Damage",
        text: "Debris damage to roof and skylights"
      }
    ]
  }),
  methods: {
    gotoDamage() {
      router.push("/damage");
    },
    gotoWind() {
      router.push("/wind");
    }
  }
};
</script>
